$(document).ready(function() {
    $("footer .sitelinks").children().first("ul").children().find("ul > li").removeClass();
});

$(document).ready(function() {
    // put breadcrumb after slider, if slider is the first div
    if ($("section > div:nth-child(2)").hasClass("frame-type-ewprovider_slidercontainer")) {
        $("section > .frame-type-ewprovider_slidercontainer").first().after($(".breadcrumb"));
    }

    // wrap div around breadcrumb, if it's the first div within a section
    else {
        $(".breadcrumb").wrap("<div class='fst'></div>");
    }

    // wrap div around welcome h2
    $("h2.welc").wrap("<div class='welc-wrapper'></div>");
    if ($("h2.welc").hasClass("text-center") || $("h2.welc").hasClass("text-left") || $("h2.welc").hasClass("text-right")) {
        var savedClass = $("h2.welc").attr("class");
        $("h2.welc").parent().addClass(savedClass).removeClass("welc");
    }
});

$(document).ready(function(){
    if ($('#socialshareprivacy').length > 0){
        $('#socialshareprivacy').socialSharePrivacy({
            services : {
                'facebook': {
                    'status': 'on',
                    'dummy_img': '/fileadmin/templates/css/socialshareprivacy/images/facebook.png',
                    'perma_option': 'off',
                    'action': 'like',
                    'layout': 'button_count'
                },
                'twitter': {
                    'status': 'off'
                },
                'gplus': {
                    'status': 'off'
                }
            },
            'cookie_domain': 'http://www.isw-technik.de/',
            "css_path": "/typo3conf/ext/ewprovider/Resources/Public/css/socialshareprivacy/socialshareprivacy.css",
            "lang_path": "/typo3conf/ext/ewprovider/Resources/Public/css/socialshareprivacy/lang/",
            "language": "de"
        });
    }
});

$(document).ready(function() {
    var $lightbox = $('#lightbox'),
        $lightboxImage = $('<img />');

    $lightbox.find('.modal-body').append($lightboxImage);

    $('[data-target="#lightbox"]').on('click', function(event) {
        console.log($lightbox.find('.modal-body'));
        var originalImage = $(this).parent().find('img'),
            imageSrc = $(this).attr('href'),
            imageAlt = originalImage.attr('alt');

        $lightboxImage.attr('src', imageSrc).attr('alt', imageAlt);
    });

    $lightbox.on('shown.bs.modal', function (e) {
        var $img = $lightbox.find('img');

        $lightbox.find('.modal-dialog').css({'width': $img.width()});
    });
});


// Counter config for counter content element
$(document).ready(function() {
    // Init counterUp
    const counterUp = window.counterUp.default

    // Logic for intersection observer to init counterUp on scroll
    const callback = entries => {
        entries.forEach(entry => {
            const el = entry.target
            if (entry.isIntersecting) {
                counterUp(el, {
                    duration: 2500, // Duration of animation
                    delay: 25, // Animation delay
                })
            }
        })
    }

    // Init intersection observer for counterUp el
    const IO = new IntersectionObserver(callback, {threshold: 1})
    const el = document.querySelectorAll('.animated-counter .count-to');
    el.forEach(el => {
        IO.observe(el);
    })
});


$(document).ready(function() {
    $('.engineering-slider').owlCarousel({
        loop: false,
        margin: 22,
        nav: true,
        dotsEach: 3,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            }
        }
    })
});
